import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//import 'formiojs/dist/formio.full.min.css'
import i18n from './i18n'
import {getCommunityName,getCommunityId} from '@/api/community/communityApi'

import { resetForm } from "@/utils/ruoyi";
// 分页组件
import Pagination from "@/components/Pagination";
import ImagePreview from "@/components/ImagePreview";
import ImageUpload from "@/components/ImageUpload";
import DictTag from '@/components/DictTag'
// 全局方法挂载
Vue.prototype.resetForm = resetForm
Vue.component('Pagination', Pagination)
Vue.component('ImagePreview', ImagePreview)
Vue.component('ImageUpload', ImageUpload)
Vue.component('DictTag', DictTag)

import plugins from './plugins' // plugins
Vue.use(plugins)

// 验证全局脚本是否正确加载

Vue.prototype.getCommunityId = function(){
  return getCommunityId()
}

Vue.prototype.getNextMonth = function(){
    // 获取当前日期
    const now = new Date();
    // 设置一个月后的日期（注意月份是从0开始的，所以1月是0，2月是1，依此类推）
    now.setMonth(now.getMonth() + 1);
    // 将日期转换为字符串，并截取为"yyyy-mm-dd"格式
    const oneMonthLater = now.toISOString().slice(0, 10);
    return oneMonthLater;
}
Vue.prototype.getNextYear = function(){
    // 获取当前日期
    const now = new Date();
    // 设置一个月后的日期（注意月份是从0开始的，所以1月是0，2月是1，依此类推）
    now.setMonth(now.getMonth() + 12);
    // 将日期转换为字符串，并截取为"yyyy-mm-dd"格式
    const oneMonthLater = now.toISOString().slice(0, 10);
    return oneMonthLater;
}

Vue.prototype.getCurrentDay = function(){
    // 获取当前日期
    const now = new Date();
    // 将日期转换为字符串，并截取为"yyyy-mm-dd"格式
    const oneMonthLater = now.toISOString().slice(0, 10);
    return oneMonthLater;
}

Vue.prototype.getCommunityName = function(){
  return getCommunityName()
}

Vue.prototype.hasPrivilege = function(_privaleges) {
  // 确保 _privaleges 是数组，如果不是则转换为数组
  const privilegesToCheck = Array.isArray(_privaleges) ? _privaleges : [_privaleges];

  // 从本地存储获取用户权限
  let userPrivileges = localStorage.getItem('hc_staff_privilege');

  // 如果存在用户权限，则转换为数组
  if (userPrivileges) {
    userPrivileges = userPrivileges.split(',');
  } else {
    // 如果没有权限数据，直接返回 false
    return false;
  }

  // 检查用户是否有任一所需权限
  return privilegesToCheck.some(item => userPrivileges.includes(item));
}
Vue.prototype.toDoc = function(url) {
  window.open('http://www.homecommunity.cn/'+url, '_blank')
}

Vue.prototype.$getUser = function() {
  let user = JSON.parse(localStorage.getItem('user'))
  return user
}


Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
